/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Button,
  Tab,
  TabList,
  useColorMode,
  useColorStyle,
  useTheme,
} from '@tonic-one/react';
import React from 'react';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

function ButtonTab({ children, ...rest }: any) {
  useWhyDidYouUpdate('ButtonTab', { children, ...rest });
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const baseStyle = {
    _selected: {
      border: 'none',
    },
    _hover: {
      border: 'none',
    },
  };
  return (
    <Tab {...rest} mr="4x">
      {({
        getTabProps,
        disabled,
        isSelected,
      }: {
        disabled: boolean;
        isSelected: boolean;
        getTabProps: Function;
      }) => {
        return (
          <Button
            borderRadius="2rem"
            disabled={disabled}
            variant={isSelected ? 'primary' : 'default'}
            {...getTabProps()}
            {...baseStyle}
            borderWidth="0px"
            color={isSelected ? 'white' : colorStyle.color.secondary}
          >
            {children}
          </Button>
        );
      }}
    </Tab>
  );
}

export default ButtonTab;
